'use client'

import { Col, Row } from 'antd'
import posthog from 'posthog-js'
import { useFeatureFlagEnabled } from 'posthog-js/react'
import { useEffect } from 'react'

export function Maintenance() {
  const isMaintenance = useFeatureFlagEnabled('maintenance')

  useEffect(() => {
    // TODO think about redirect to make everything reconnect
    const interval = setInterval(() => {
      posthog.reloadFeatureFlags()
    }, 60_000 * 5) // recheck every 5 minutes

    return () => clearInterval(interval)
  }, [isMaintenance])

  if (!isMaintenance) {
    return null
  }

  return (
    <Row
      style={{
        backdropFilter: 'blur(4px)',
        background: 'rgba(252,250,242,0.7)',
        bottom: 0,
        left: 0,
        position: 'fixed',
        right: 0,
        top: 0,
        zIndex: Number.MAX_SAFE_INTEGER,
      }}
      align={'middle'}
      justify={'center'}
    >
      <Col >
        <h1>We&rsquo;ll be back soon!</h1>
        <p style={{ maxWidth: 400 }}>Sorry for the inconvenience but we&rsquo;re performing some maintenance at the moment. If you need to you can always <a href="mailto:team@tucan.ai">contact us</a>, otherwise we&rsquo;ll be back online shortly!</p>
        <p>&mdash; The Team</p>
      </Col>
    </Row>
  )
}
